import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FiMapPin } from 'react-icons/fi';
import styles from './LocationPicker.module.css';

const SelectLocationPrompt = ({ isOpen, location, onConfirm, onDismiss }) => {
  const [shouldApply, setShouldApply] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setShouldApply(true);
    }
  }, [isOpen, location?.id]);

  if (!isOpen || !location) return null;

  return (
    <div className={styles.promptOverlay} role="dialog" aria-modal="true">
      <div className={styles.promptCard}>
        <div className={styles.promptHeader}>
          <FiMapPin />
          <div>
            <h4 style={{ margin: 0 }}>Set this new location?</h4>
            <p className={styles.quiet} style={{ margin: '4px 0 0' }}>
              Set this new location as the selected location for this stop?
            </p>
          </div>
        </div>
        <div className={styles.promptActions}>
          <label className={styles.promptCheckbox}>
            <input
              type="checkbox"
              checked={shouldApply}
              onChange={(event) => setShouldApply(event.target.checked)}
            />
            <span>Yes, set {location.name || location.company_name || 'this location'} now</span>
          </label>
          <div className={styles.promptButtons}>
            <button type="button" onClick={onDismiss}>
              Keep current
            </button>
            <button
              type="button"
              className={styles.primary}
              onClick={() => {
                onConfirm(shouldApply);
              }}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

SelectLocationPrompt.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    company_name: PropTypes.string,
  }),
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

SelectLocationPrompt.defaultProps = {
  location: null,
};

export default SelectLocationPrompt;
